export default "__VITE_ASSET__jx9elKGX__"